<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/scpq39/tc-custom/9780369712912.jpg?1743850083315" alt="This image is the cover for the book Billionaire's Road Trip to Forever"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Billionaire's Road Trip to Forever
      </h1>
      <p class="bookDescription body article font2">
        <b>Running from a wedding…</b><br/><i>… to a whole new future!</i><br/>Bree Allenby’s first stop on her road trip across Australia is to attend the society wedding of her brother’s best friend. When Noah Fitzgerald is dramatically jilted, he needs a quick getaway—so Bree suggests he come with her! Spending her days with a billionaire is not what she was expecting… Not only is their spark of attraction completely new, but it has them both rethinking where they’re going in life!<br/><br/>“An emotionally riveting journey…Michelle Douglas shines in <i>Secret Billionaire on Her Doorstep</i>…. The story is fast paced with many ups and downs and I found myself unable to put it down until I found out how it was going to end. I highly recommend this book….”<br/>-<i>Goodreads</i><br/><br/>“Michelle Douglas always takes me on wonderful journeys filled with love, emotion and romance…this is a book that should not be missed, I loved it so much I highly recommend this one.”<br/>-<i>Goodreads</i> on <i>Singapore Fling with the Millionaire</i><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michelle Douglas
      </h2>
      
      <p class="authorDescription body article">MICHELLE DOUGLAS has been writing for Mills &amp; Boon since 2007, and believes she has the best job in the world. She&#39;s a sucker for happy endings, heroines who have a secret stash of chocolate, and heroes who know how to laugh. She lives in Newcastle Australia with her own romantic hero, a house full of dust and books, and an eclectic collection of sixties and seventies vinyl. She loves to hear from readers and can be contacted via her website www.michelle-douglas.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22856122